import { useEffect, lazy, Suspense, useState } from "react";
import { saveLastRoute } from "./Utilities/routePersistence";
import "./App.css";
import "./styles/exchange-styles/exchange-utility.css";
import "./styles/FBDarkTheme.scss";
import { BrowserRouter, Route, Routes, useLocation } from "react-router-dom";
import ExchangeContext from "./context/ExchangeContext";
import User from "./context/User";
import Header from "./Components/Header/Header";
import GlobalToast from "./context/GlobalToast";
import Theme from "./context/Theme";
import ScrollToTop from "./Components/ScrollToTop/ScrollToTop";
import BottomNavigation from "./Components/BottomNavigation/BottomNavigation";
import Loader from "./Components/Loader/Loader";
import NoInternetModel from "./Components/NoInternetModel/NoInternetModel";

// Lazy imports
const ExchangeMarketPageView = lazy(() => import("./Views/ExchangeViews/ExchangeMarketView/ExchangeMarketView"));
const OpenBetsComponent = lazy(() => import("./Components/ExchangeComponents/OpenBetsComponent/OpenBetsComponent"));
const MainPage = lazy(() => import("./Pages/MainPage/MainPage"));
const InplaySports = lazy(() => import("./Pages/InplaySports/InplaySports"));
const UpcomingSports = lazy(() => import("./Pages/UpcomingSports/UpcomingSports"));
const ValidateUserPage = lazy(() => import("./Pages/ValidateUserPage/ValidateUserPage"));
const ProfitLoss = lazy(() => import("./Pages/ProfitLoss/ProfitLoss"));
const MultiPinned = lazy(() => import("./Pages/MultiPinned/MultiPinned"));
const CasinoPage = lazy(() => import("./Pages/Casino/CasinoPage/CasinoPage"));
const LiveStream = lazy(() => import("./Pages/LiveStream/LiveStream"));
const LiveScoreIframe = lazy(() => import("./Pages/Iframes/LiveScoreIframe/LiveScoreIframe"));

const App = () => {
  const [showInternetModel, setShowInternetModel] = useState(false);
  // disable zoom 



  const checkNetworkConnection = () => {
    if (!navigator.onLine) {
      setShowInternetModel(true);
    } else {
      setShowInternetModel(false);
    }
  };


  useEffect(() => {
    checkNetworkConnection();
    checkNetworkConnection();

    // Listen for network changes
    window.addEventListener("online", checkNetworkConnection);
    window.addEventListener("offline", checkNetworkConnection);


    document.addEventListener(
      "wheel",
      function (event) {
        if (event.ctrlKey) {
          event.preventDefault();
        }
      },
      { passive: false }
    );

    document.addEventListener("keydown", function (event) {
      if (event.ctrlKey && (event.key === "+" || event.key === "-" || event.key === "0")) {
        event.preventDefault();
      }
    });

    document.addEventListener("gesturestart", function (event) {
      event.preventDefault();
    });
  }, []);

  return (
    <ExchangeContext>
      <GlobalToast>
        <User>
          <Theme>
            <BrowserRouter>
              <RoutePersistence />
              <ConditionalHeader />
              <ScrollToTop />
              {showInternetModel && <NoInternetModel closeModel={()=>setShowInternetModel(false)} />}
              <Suspense fallback={<Loader />}>
                <Routes>
                  <Route path="/" element={<MainPage />} />
                  <Route path="exchange-v1/:token/:providerId" element={<ValidateUserPage />} />
                  <Route path="inplay" element={<InplaySports />} />
                  <Route path="upcoming" element={<UpcomingSports />} />
                  <Route path="exchange/m-pinned" element={<MultiPinned />} />
                  <Route path="casino/lobby" element={<CasinoPage />} />
                  <Route path="sports/exchange/live-stream/:code" element={<LiveStream />} />
                  <Route path="sports/exchange/live-score/:code" element={<LiveScoreIframe />} />
                  <Route path="exchange/markets/:code" element={<ExchangeMarketPageView />} />
                  <Route path="exchange/openbets-all" element={<OpenBetsComponent hideBack={false} ALL={true} />} />
                  <Route path="bets/profit-loss" element={<ProfitLoss />} />
                </Routes>
              </Suspense>
              <ConditionalBottomNavigation />
            </BrowserRouter>
          </Theme>
        </User>
      </GlobalToast>
    </ExchangeContext>
  );
};

const RoutePersistence = () => {
  const location = useLocation();

  useEffect(() => {
    saveLastRoute(location.pathname);
  }, [location.pathname]);

  return null;
};

const ConditionalBottomNavigation = () => {
  const location = useLocation();
  if (
    !(
      location.pathname.includes("/sports/exchange/live-stream/") ||
      location.pathname.includes("/sports/exchange/live-score/")
    )
  ) {
    return <BottomNavigation />;
  }
  return null;
};

const ConditionalHeader = () => {
  const location = useLocation();

  // Define routes where the Header should not be displayed
  const hideHeaderRoutes = [/^\/exchange-v1(\/.*)?$/];

  // Check if the current path matches any of the `hideHeaderRoutes` patterns
  const shouldHideHeader = hideHeaderRoutes.some((route) =>
    route.test(location.pathname)
  );

  return (
    !shouldHideHeader &&
    !(
      location.pathname.includes("/sports/exchange/live-stream/") ||
      location.pathname.includes("/sports/exchange/live-score")
    ) && <Header />
  );
};




export default App;
